import React, { createContext, useContext, useReducer, useCallback } from 'react';

const CartContext = createContext(null);

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD': {
      const existing = state.findIndex((i) => i.cartId === action.item.cartId);
      if (existing !== -1) {
        return state.map((i, idx) =>
          idx === existing ? { ...i, qty: i.qty + 1 } : i
        );
      }
      return [...state, { ...action.item, qty: 1 }];
    }
    case 'INCREMENT':
      return state.map((i) => i.cartId === action.cartId ? { ...i, qty: i.qty + 1 } : i);
    case 'DECREMENT':
      return state
        .map((i) => i.cartId === action.cartId ? { ...i, qty: i.qty - 1 } : i)
        .filter((i) => i.qty > 0);
    case 'REMOVE':
      return state.filter((i) => i.cartId !== action.cartId);
    case 'CLEAR':
      return [];
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [items, dispatch] = useReducer(cartReducer, []);

  const addItem = useCallback((item) => dispatch({ type: 'ADD', item }), []);
  const increment = useCallback((cartId) => dispatch({ type: 'INCREMENT', cartId }), []);
  const decrement = useCallback((cartId) => dispatch({ type: 'DECREMENT', cartId }), []);
  const removeItem = useCallback((cartId) => dispatch({ type: 'REMOVE', cartId }), []);
  const clearCart = useCallback(() => dispatch({ type: 'CLEAR' }), []);

  const totalCount = items.reduce((s, i) => s + i.qty, 0);
  const totalPrice = items.reduce((s, i) => s + i.qty * (i.unitPrice || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, increment, decrement, removeItem, clearCart, totalCount, totalPrice }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used inside CartProvider');
  return ctx;
}
